export default __webpack_public_path__ + "static/media/redux.5de70b7b.png";